import { chalkLine } from '../../primitives/chalk';

async function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
    img.src = src;
  });
}

export async function prepareImageDrawNode(env, spec) {
  const area = env.boardArea();
  const src = spec.src || spec.url || '';
  if (!src) {
    throw new Error('IMAGE_DRAW requires src');
  }

  const image = await loadImage(src);
  const scale = Math.min(area.w / image.width, area.h / image.height);
  const drawW = Math.max(1, image.width * scale);
  const drawH = Math.max(1, image.height * scale);
  const drawX = area.x + (area.w - drawW) / 2;
  const drawY = area.y + (area.h - drawH) / 2;

  return {
    image,
    srcW: image.width,
    srcH: image.height,
    drawX,
    drawY,
    drawW,
    drawH,
    durationSec: spec.draw?.durationSec || 2.2,
    showHand: spec.draw?.showHand ?? true,
    handRadius: spec.draw?.handRadius || 8,
  };
}

export function commitImageDrawNode(packet, ctxs, anim) {
  let t = 0;

  anim.add((dt) => {
    t += dt;
    const progress = Math.min(t / packet.durationSec, 1);
    const visibleH = packet.drawH * progress;
    const sourceVisibleH = packet.srcH * progress;

    ctxs.ink.clearRect(packet.drawX - 2, packet.drawY - 2, packet.drawW + 4, packet.drawH + 4);

    if (visibleH > 0.5 && sourceVisibleH > 0.5) {
      ctxs.ink.drawImage(
        packet.image,
        0,
        0,
        packet.srcW,
        sourceVisibleH,
        packet.drawX,
        packet.drawY,
        packet.drawW,
        visibleH
      );
    }

    const traceY = packet.drawY + visibleH;
    if (progress < 1) {
      chalkLine(ctxs.ink, packet.drawX, traceY, packet.drawX + packet.drawW, traceY, 1.6, 0.5);
    }

    if (packet.showHand && progress < 1) {
      const handX = packet.drawX + packet.drawW * 0.92;
      ctxs.ink.save();
      ctxs.ink.fillStyle = 'rgba(245, 250, 255, 0.92)';
      ctxs.ink.beginPath();
      ctxs.ink.arc(handX, traceY, packet.handRadius, 0, Math.PI * 2);
      ctxs.ink.fill();
      ctxs.ink.restore();
    }

    if (progress >= 1) {
      ctxs.ink.clearRect(packet.drawX - 2, packet.drawY - 2, packet.drawW + 4, packet.drawH + 4);
      ctxs.ink.drawImage(packet.image, packet.drawX, packet.drawY, packet.drawW, packet.drawH);
      return false;
    }
    return true;
  });
}
